import React from 'react'

const MiscellaneousPage = () => {
  return (
    <div>MiscellaneousPage</div>
  )
}

export default MiscellaneousPage;